import React from 'react'
import '../App.css'

const Contact = () => {
    return (
        <div className="About-area">
            <h2 className="heading">CONTACT</h2>
            <p>
				<a href="mailto:nobelroyp12a@yahoo.com"><i className="fa fa-envelope contact-items"></i> Email</a><br/>
                <a href="tel:+91 9074881959"><i className="fa fa-phone contact-items"></i> Phone</a>
			</p>
        </div>
    )
}
export default Contact
